import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * Rest-Service que trabaja con las notificaciones. Permite:
 *
 * Obtener notificaciones
 * Actualizar su estado (Leída / No Leída)
 */
var NotificacionesRestService = /** @class */ (function () {
    function NotificacionesRestService(httpClient) {
        this.httpClient = httpClient;
    }
    NotificacionesRestService.prototype.obtenerNotificaciones = function () {
        return this.httpClient.get(environment.apiURL + 'v1/notificaciones');
    };
    NotificacionesRestService.prototype.contarNotificacionesNoLeidas = function () {
        return this.httpClient.get(environment.apiURL + 'v1/notificaciones/contarNotificacionesNoLeidas');
    };
    NotificacionesRestService.prototype.actualizarLecturaNotificacion = function (notificacion) {
        return this.httpClient.post(environment.apiURL + 'v1/notificaciones/' + notificacion.id + '/actualizar-marca-lectura', { marcaLectura: notificacion.leida });
    };
    NotificacionesRestService.prototype.obtenerNotificacion = function (idNotificacion) {
        return this.httpClient.get(environment.apiURL + 'v1/notificaciones/' + idNotificacion);
    };
    NotificacionesRestService.ngInjectableDef = i0.defineInjectable({ factory: function NotificacionesRestService_Factory() { return new NotificacionesRestService(i0.inject(i1.HttpClient)); }, token: NotificacionesRestService, providedIn: "root" });
    return NotificacionesRestService;
}());
export { NotificacionesRestService };
